import { useEffect, useState } from 'react';
import styled from 'styled-components';

import globalModules from 'common/utilities/GlobalModulatorUtils';
import { createStyleString } from 'common/utilities/utils';
import STYLE_SCRIPT_CONST from 'common/style-scripts/constants';

const styleStringWithDiv = styleString => styled.div`
  ${styleString}
`;

const styleStringWithColRows = (styleString, paramsColRows) => styled(paramsColRows)`
  ${styleString}
`;

const calculatePaddingBottom = props => {
  return `${props.paddingBottom}px`;
};

const footerStyleScript = styleString => styled.footer`
  ${styleString}
  @media (max-width: 1023px) {
    padding-bottom: ${props => calculatePaddingBottom(props)};
  }
`;

const menuCategoryStylesMobileStyleScript = (globalStyleConstantData, styleString, paramsColRows) => {
  const { addPixelValues, STICKY_TOP_VALUES } = globalStyleConstantData.modulesData;
  const topNonLocalized = STICKY_TOP_VALUES?.mobile?.topNonLocalized;
  return styled(paramsColRows)`
    ${styleString}
    position: ${props => (props?.isSmartBannerVisible?.toString() === 'true' ? 'relative' : 'fixed')};
    top: ${props => (props?.isSmartBannerVisible?.toString() === 'true' ? '0' : topNonLocalized)};
    &.localized {
      top: ${props =>
        props?.isSmartBannerVisible?.toString() === 'true'
          ? '0'
          : addPixelValues(STICKY_TOP_VALUES?.mobile?.topLocalized, props?.topValue)};
    }
    &.nonLocalizeGuide {
      top: ${props =>
        props?.isSmartBannerVisible?.toString() === 'true' ? 'unset' : addPixelValues(props?.topGuideValue)};
    }
  `;
};

export const executeStyledScripts = (globalStyleConstantData, paramsConst, paramsColRows) => {
  if (globalStyleConstantData?.modulesData) {
    const styleString = createStyleString(globalStyleConstantData?.modulesData?.[paramsConst]);
    switch (paramsConst) {
      case STYLE_SCRIPT_CONST?.HEADER_STYLES:
      case STYLE_SCRIPT_CONST?.CONTACT_US_CONTAINER_STYLES:
      case STYLE_SCRIPT_CONST?.TERMS_OS_USE_STYLES:
      case STYLE_SCRIPT_CONST?.START_ORDER_BTN_STYLES:
      case STYLE_SCRIPT_CONST?.START_ORDER_STYLES:
      case STYLE_SCRIPT_CONST?.DISPOSITION_BAR_STYLES:
      case STYLE_SCRIPT_CONST?.PROTECTED_DISCLOSURE_STYLES:
      case STYLE_SCRIPT_CONST?.OUR_ADS_STYLES:
      case STYLE_SCRIPT_CONST?.FAQ_CONTAINER_STYLES:
        return paramsColRows ? styleStringWithColRows(styleString, paramsColRows) : styleStringWithDiv(styleString);

      case STYLE_SCRIPT_CONST?.FOOTER_STYLES:
        return footerStyleScript(styleString);

      case STYLE_SCRIPT_CONST?.MENU_CATEGORY_STYLES_DESKTOP:
        return styleStringWithColRows(styleString, paramsColRows);

      case STYLE_SCRIPT_CONST?.MENU_CATEGORY_STYLES_MOBILE:
        return menuCategoryStylesMobileStyleScript(globalStyleConstantData, styleString, paramsColRows);
      // no default
    }
  }
  return '';
};

const useStyleScripts = (paramsConst, paramsColRows = null) => {
  const { globalStyleConstantData } = globalModules;
  const [styledDiv, setStyledDiv] = useState('');

  useEffect(() => {
    setStyledDiv(executeStyledScripts(globalStyleConstantData, paramsConst, paramsColRows));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalStyleConstantData?.modulesData]);

  return styledDiv;
};

export default useStyleScripts;
